module.exports = __webpack_public_path__ + "img/icon-dashboard.1fbdf900.svg";